
// @ts-nocheck


export const localeCodes =  [
  "en",
  "it",
  "fr",
  "de",
  "es",
  "pt"
]

export const localeLoaders = {
  "en": [{ key: "../../../../app/translations/en.ts", load: () => import("../../../../app/translations/en.ts?hash=e9b4ee18&locale=en" /* webpackChunkName: "locale__app_apps_business_app_translations_en_ts" */), cache: false }],
  "it": [{ key: "../../../../app/translations/it.ts", load: () => import("../../../../app/translations/it.ts?hash=63218575&locale=it" /* webpackChunkName: "locale__app_apps_business_app_translations_it_ts" */), cache: false }],
  "fr": [{ key: "../../../../app/translations/fr.ts", load: () => import("../../../../app/translations/fr.ts?hash=2ccc7b4a&locale=fr" /* webpackChunkName: "locale__app_apps_business_app_translations_fr_ts" */), cache: false }],
  "de": [{ key: "../../../../app/translations/de.ts", load: () => import("../../../../app/translations/de.ts?hash=97216fd5&locale=de" /* webpackChunkName: "locale__app_apps_business_app_translations_de_ts" */), cache: false }],
  "es": [{ key: "../../../../app/translations/es.ts", load: () => import("../../../../app/translations/es.ts?hash=bf75a6c8&locale=es" /* webpackChunkName: "locale__app_apps_business_app_translations_es_ts" */), cache: false }],
  "pt": [{ key: "../../../../app/translations/pt.ts", load: () => import("../../../../app/translations/pt.ts?hash=d8dfa503&locale=pt" /* webpackChunkName: "locale__app_apps_business_app_translations_pt_ts" */), cache: false }]
}

export const vueI18nConfigs = [
  () => import("../../../../i18n.config.ts?hash=99279338&config=1" /* webpackChunkName: "i18n_config_99279338" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "./app/domains/i18n/utils/localeDetector.ts",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "language": "en-GB",
      "files": [
        "/app/apps/business/app/translations/en.ts"
      ]
    },
    {
      "code": "it",
      "language": "it-IT",
      "files": [
        "/app/apps/business/app/translations/it.ts"
      ]
    },
    {
      "code": "fr",
      "language": "fr-FR",
      "files": [
        "/app/apps/business/app/translations/fr.ts"
      ]
    },
    {
      "code": "de",
      "language": "de",
      "files": [
        "/app/apps/business/app/translations/de.ts"
      ]
    },
    {
      "code": "es",
      "language": "es-ES",
      "files": [
        "/app/apps/business/app/translations/es.ts"
      ]
    },
    {
      "code": "pt",
      "language": "pt-PT",
      "files": [
        "/app/apps/business/app/translations/pt.ts"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "translations",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "no prefix",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://business.foodlista.it",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en-GB",
    "files": [
      {
        "path": "/app/apps/business/app/translations/en.ts"
      }
    ]
  },
  {
    "code": "it",
    "language": "it-IT",
    "files": [
      {
        "path": "/app/apps/business/app/translations/it.ts"
      }
    ]
  },
  {
    "code": "fr",
    "language": "fr-FR",
    "files": [
      {
        "path": "/app/apps/business/app/translations/fr.ts"
      }
    ]
  },
  {
    "code": "de",
    "language": "de",
    "files": [
      {
        "path": "/app/apps/business/app/translations/de.ts"
      }
    ]
  },
  {
    "code": "es",
    "language": "es-ES",
    "files": [
      {
        "path": "/app/apps/business/app/translations/es.ts"
      }
    ]
  },
  {
    "code": "pt",
    "language": "pt-PT",
    "files": [
      {
        "path": "/app/apps/business/app/translations/pt.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
